import { createUniqueId } from './helper'
import ITEMS from '../constants/ITEMS'

const createItemBase = (itemSource, tier, modifiers, name) => ({
    ID: `item_${createUniqueId()}`,
    source: itemSource,
    tier: tier || 1,
    modifiers: modifiers || undefined,
    name: name || ITEMS[itemSource].name,
})

const getItemData = (itemBase) => {
    const { source } = itemBase
    return Object.assign({}, ITEMS[source], itemBase)
}

export default {
    createItemBase,
    getItemData,
}
